import * as yup from 'yup';
import { EXTENDED_LANG_TO_COUNTRY, COUNTRY_TO_FLAG } from '../../../utils/languageUtils';

/**
 * Get language options with correct flags based on the language-to-country mapping
 * Aligned with server I18nLang enum
 */
export const getLanguageOptions = (t: (key: string) => string) => [
  { value: 0, label: t('English') },
  { value: 1, label: t('French') },
  { value: 2, label: t('German') },
  { value: 3, label: t('Italian') },
  { value: 4, label: t('Spanish') },
  { value: 5, label: t('Dutch') },
  { value: 6, label: t('Polish') },
  { value: 7, label: t('Portuguese') },
  { value: 8, label: t('Russian') },
  { value: 9, label: t('Czech') },
  { value: 10, label: t('Slovak') },
  { value: 11, label: t('Hungarian') },
  { value: 12, label: t('Romanian') },
  { value: 13, label: t('Bulgarian') },
  { value: 14, label: t('Croatian') },
  { value: 15, label: t('Slovenian') },
  { value: 16, label: t('Swedish') },
  { value: 17, label: t('Norwegian') },
  { value: 18, label: t('Danish') },
  { value: 19, label: t('Finnish') },
  { value: 20, label: t('Greek') },
  { value: 21, label: t('Turkish') },
].map(opt => {
  const countryCode = EXTENDED_LANG_TO_COUNTRY[opt.value];
  return {
    ...opt,
    flag: countryCode ? COUNTRY_TO_FLAG[countryCode] || '' : ''
  };
});

/**
 * Get safety certificate options
 */
export const getSafetyCertificateOptions = (t: (key: string) => string) => [
  { value: 'ADR', label: t('ADR (ADR)') },
  { value: 'ADR_BASIC', label: t('ADR (ADR Basic)') },
  { value: 'DANGEROUS_GOODS', label: t('DANGEROUS_GOODS (Dangerous Goods)') },
  { value: 'HACCP', label: t('HACCP (Food Safety)') },
  { value: 'ISO_9001', label: t('ISO 9001 (Quality Management)') },
  { value: 'ISO_14001', label: t('ISO 14001 (Environmental)') },
  { value: 'OHSAS_18001', label: t('OHSAS 18001 (Safety)') },
  { value: 'BRC', label: t('BRC (Food Safety)') },
  { value: 'IFS', label: t('IFS (Food Safety)') },
  { value: 'FSSC_22000', label: t('FSSC 22000 (Food Safety)') },
  { value: 'SQF', label: t('SQF (Food Safety)') },
  { value: 'GLOBALGAP', label: t('GLOBALGAP (Agricultural)') },
];

/**
 * Validation schema for driver forms
 */
export const getDriverValidationSchema = (t: (key: string) => string) => yup.object({
  first_name: yup.string().required(t('First name is required')),
  last_name: yup.string().required(t('Last name is required')),
  email: yup.string().email(t('Invalid email format')).optional(),
  coordinates: yup.string().required(t('Coordinates are required')).test('valid-coordinates', t('Invalid coordinates format. Use: latitude, longitude'), function (value) {
    if (!value) return false;
    const parts = value.split(',').map(part => part.trim());
    if (parts.length !== 2) return false;

    const lat = parseFloat(parts[0]);
    const lng = parseFloat(parts[1]);

    if (isNaN(lat) || isNaN(lng)) return false;
    if (lat < -90 || lat > 90) return false;
    if (lng < -180 || lng > 180) return false;

    return true;
  }),
  known_languages: yup.array().of(yup.number()).optional(),
  safety_certificates: yup.array().of(yup.string()).optional(),
  base_country: yup.string().required(t('Base country is required')).length(2, t('Country code must be 2 letters')),
});
